// Clerk configuration and utilities

export const CLERK_CONFIG = {
  publishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '',
  // Add other Clerk configuration options here
  appearance: {
    baseTheme: undefined, // We'll use custom styling
    variables: {
      colorPrimary: '#363232', // Our accent color
      colorBackground: '#F8F5F2', // Our background color
      colorText: '#363232', // Our primary text color
      fontFamily: 'Space Grotesk, sans-serif',
    },
    elements: {
      formButtonPrimary: 'bg-accent hover:bg-yellow-400 text-primary-text font-space',
      card: 'bg-background border border-subtle shadow-lg',
      headerTitle: 'text-primary-text font-space font-semibold',
      headerSubtitle: 'text-primary-text font-space',
      socialButtonsBlockButton: 'border border-subtle hover:bg-subtle',
      formFieldInput: 'border border-subtle focus:border-accent bg-white text-primary-text font-space',
      formFieldLabel: 'text-primary-text font-space font-medium',
      identityPreviewText: 'text-primary-text font-space',
      identityPreviewEditButton: 'text-accent hover:text-yellow-600 font-space',
      rootBox: 'z-50',
      modal: 'z-50',
      modalBackdrop: 'z-40',
      overlay: 'z-50',
    }
  }
};

// Helper function to check if Clerk is properly configured
export const isClerkConfigured = (): boolean => {
  return Boolean(CLERK_CONFIG.publishableKey);
};

// Helper to format user display name
export const getUserDisplayName = (user: any): string => {
  if (user?.firstName && user?.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  if (user?.firstName) {
    return user.firstName;
  }
  if (user?.emailAddresses?.[0]?.emailAddress) {
    return user.emailAddresses[0].emailAddress;
  }
  return 'User';
};
